<script lang="ts">
	import LinkInValue from './LinkInValue.svelte'
	import Value from './Value.svelte'
	import { type Column, ColumnType } from './types'
	import { _ } from '@repo/i18n'
	import { ShortText } from '@repo/ui'
	import { CopyButton } from '@repo/ui'
	import { StatusLabel } from '@repo/ui'
	import { Tooltip } from '@repo/ui'

	interface Props {
		column: Column<any>
		row: any
		onclick?: (event: Event) => void
	}

	let { column, row, onclick = null }: Props = $props()
</script>

{#if column.valueTooltip && column.valueTooltip(row)}
	<div class="mr-0.5 inline-flex h-[22px] items-center align-middle">
		<Tooltip>
			{column.valueTooltip(row).text}
		</Tooltip>
	</div>
{/if}

{#if column.component}
	{#if column.type === ColumnType.action}
		<!-- prevent to select table row -->
		<!-- svelte-ignore a11y_no_static_element_interactions,  a11y_click_events_have_key_events -->
		<div
			onclick={(e) => {
				e.stopPropagation()
				onclick?.(e)
			}}
		>
			<column.component {...column.params(row)} />
		</div>
	{:else}
		<column.component {...column.params(row)} />
	{/if}
{:else if column.link}
	{#if column.value(row)}
		{#if column.type === ColumnType.id}
			<Value columnType={column.type} link={column.link(row)} value={column.value(row)} />
		{:else}
			<LinkInValue href={column.link(row)}>
				<Value columnType={column.type} value={column.value(row)} />
			</LinkInValue>
		{/if}
	{/if}
{:else if column.status}
	<StatusLabel status={column.status(row)} />
{:else if column.statuses}
	{@const statuses = column.statuses(row)}
	{#if statuses}
		<div class="flex space-x-2">
			{#each column.statuses(row) as status (status.label)}
				<StatusLabel {status} />
			{/each}
		</div>
	{/if}
{:else if column.shortText}
	<ShortText
		maxLength={column.shortText.maxLength}
		truncateType={column.shortText.truncateType}
		value={column.value(row).toString()}
	/>
{:else}
	<Value columnType={column.type} value={column.value(row)} />
	{#if column.original?.value(row) && column.original.value(row)['value'] !== column.value(row)['value']}
		<div class="ml-0.5 inline-flex h-[22px] items-center align-middle">
			<Tooltip>
				<b>
					{$_(column.original.header)}:
				</b>
				<Value columnType={column.type} value={column.original.value(row)} />

				{#if column.lastUpdated(row)}
					<div>
						<b>
							{$_('dataGrid.lastUpdated')}:
						</b>
						<Value columnType={ColumnType.datetime} value={column.lastUpdated(row)} />
					</div>
				{/if}
			</Tooltip>
		</div>
	{/if}
{/if}

{#if column.copyButton}
	<div class="ml-2"></div>
	<CopyButton text={column.value(row).toString()} />
	<div class="ml-2"></div>
{/if}
